
import { TypographyType } from '@/ui-kit/components/typography/enums';
import Typography from '@/ui-kit/components/typography';
import ListingPropertyCharacteristics from '../property-characteristics';
import IconHintTooltip from '@/components/shared/tooltips/icon-hint-tooltip';
import { IconHintTooltipProperty } from '@/components/shared/tooltips/icon-hint-tooltip/enum';

const DEFAULT_COLUMN_AMOUNT = 2;
const COLUMNS_COUNT_CSS_VARIABLE = '--columns-count';

export default {
  name: 'ListingPropertyOverview',
  components: {
    IconHintTooltip,
    Typography,
    ListingPropertyCharacteristics,
  },
  props: {
    title: {
      required: true,
      type: String,
    },
    tooltipMessage: {
      required: true,
      type: String,
    },
    characteristics: {
      required: true,
      type: Array,
    },
    columnsCount: {
      default: DEFAULT_COLUMN_AMOUNT,
      type: Number,
    },
  },
  data() {
    return {
      TypographyType,
      IconHintTooltipProperty,
    };
  },
  computed: {
    sectionStyle() {
      return {
        [COLUMNS_COUNT_CSS_VARIABLE]: this.columnsCount,
      };
    },
  },
};
